import React from 'react';
import { FieldValues, Resolver } from 'react-hook-form';
import * as yup from 'yup';
import { createYupValidationResolver } from './createYupValidationResolver';

export const useYupValidationResolver = <TFieldValues extends FieldValues>(
  validationSchema: yup.SchemaOf<TFieldValues>,
): Resolver<TFieldValues> => React.useMemo(() => createYupValidationResolver(validationSchema), [validationSchema]);
